import styled from 'styled-components';

export const ScHeroV2 = styled.div<{ isImagesHidden?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 16px;

  & > picture {
    display: block;
  }

  & .hero__container {
    display: flex;
    color: white;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 20px;
    padding: 40px;
    position: relative;
    width: 600px;
    flex-shrink: 0;

    & > picture {
      display: none;
    }
  }

  & .image-mob {
    display: none;
  }

  & .hero__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 32px;

    & > div:empty {
      display: none;
    }

    & .big-offer {
      & > div {
        display: flex;
        align-items: center;
        column-gap: 8px;
        font-weight: 700;
        text-transform: uppercase;
        @media (max-width: 768px) {
          justify-content: center;
        }
      }

      & span {
        font-size: 80px;
        line-height: 80px;
        @media (max-width: 768px) {
          font-size: 64px;
          line-height: 64px;
        }
      }

      & .right {
        text-align: left;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: 0.03em;
        @media (max-width: 768px) {
          font-size: 24px;
          line-height: 24px;
        }
      }
      &__bottom {
        color: #f0c018;
        margin-top: -8px;
      }
    }

    & .hero__offer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    & .button-link {
      align-self: stretch;
      & > button {
        width: 100%;
      }
    }
  }

  & .hero__text1 {
    font-size: 22px;
    letter-spacing: 0.02em;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  & .hero__text2 {
    text-align: left;
    display: flex;
    column-gap: 8px;
    align-items: center;

    &-1 {
      font-size: 80px;
      line-height: 80px;
      text-align: left;
    }

    &-2 {
      font-size: 32px;
      display: inline-block;
      max-width: min-content;
      line-height: 32px;
      text-align: left;
      letter-spacing: 0.03em;
    }

    &.de {
      .hero__text2-1,
      .hero__text2-2 {
        font-size: 40px;
        line-height: 40px;
      }
      .hero__text2-1 {
        margin-right: 8px;
      }
    }
  }

  & .hero__text3 {
    font-size: 22px;
    color: #f0c018;
    letter-spacing: 0.02em;
  }

  & .hero__imgContainer {
    position: absolute;
    bottom: 0;
    right: -65px;
  }

  & .flying-elements {
    z-index: 1000;
  }

  @media (max-width: 768px) {
    & .image-mob {
      display: block;
    }

    & > picture {
      display: none;
    }

    & .hero__container {
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      text-align: center;

      padding: 16px;

      & > picture {
        display: block;
      }

      & .hero__content {
        width: 100%;
        align-items: center;
        justify-content: center;

        text-align: center;

        gap: 16px;

        & .button-link > button {
          margin-bottom: 0;
        }

        & .hero__offer {
          justify-content: center;
          align-items: center;

          & > .hero__text2 {
            width: 100%;
            text-align: center;
            flex-direction: column;

            & > span {
              display: block;
              max-width: 100%;

              &.hero__text2-1 {
                font-size: 72px;
                line-height: 72px;
                text-align: center;
              }
              &.hero__text2-2 {
                font-size: 28px;
                line-height: 36px;
                text-align: center;
              }
            }

            &.de {
              .hero__text2-1 {
                margin-right: 0;
              }
            }
          }
        }
      }
    }

    & .hero__imgContainer {
      position: relative;
      width: 100%;
      right: -16px;
      bottom: -16px;
      margin-top: -16px;
      display: flex;
      justify-content: flex-end;
      & > img {
        border-end-end-radius: 20px;
      }
    }

    & .image-desk {
      display: none;
    }
  }
`;
